<div class="qmia" [class.qmia--chat-aberto]="aba === 'conversas' && selecionadoId">

  <!-- ===== Cabeçalho: título e período ===== -->
  <header class="qmia-cabecalho">
    <div>
      <h1 class="qmia-cabecalho__titulo">Qualidade da Mia</h1>
      <p class="qmia-cabecalho__sub">Avaliação da atuação pelo LLM-juiz · visível só para admins</p>
    </div>
    <div class="qmia-periodos" role="group" aria-label="Período">
      <button type="button" *ngFor="let periodo of periodos" class="qmia-periodo"
              [class.qmia-periodo--ativo]="diasSelecionados === periodo.dias"
              (click)="selecionePeriodo(periodo.dias)">{{ periodo.rotulo }}</button>
    </div>
  </header>

  <div class="qmia-alerta" *ngIf="erro" role="alert">
    <svg class="qmia-icone" viewBox="0 0 24 24" aria-hidden="true"><circle cx="12" cy="12" r="9"/><path d="M12 8v4"/><path d="M12 16h.01"/></svg>
    {{ erro }}
    <button type="button" (click)="erro = ''" aria-label="Fechar aviso">
      <svg class="qmia-icone" viewBox="0 0 24 24" aria-hidden="true"><path d="M18 6 6 18"/><path d="m6 6 12 12"/></svg>
    </button>
  </div>

  <!-- ===== Abas ===== -->
  <nav class="qmia-abas" role="tablist" aria-label="Seções da qualidade">
    <button type="button" role="tab" class="qmia-aba" [class.qmia-aba--ativa]="aba === 'visao'"
            [attr.aria-selected]="aba === 'visao'" (click)="selecioneAba('visao')">
      <svg class="qmia-icone" viewBox="0 0 24 24" aria-hidden="true"><path d="M3 3v16a2 2 0 0 0 2 2h16"/><path d="M18 17V9"/><path d="M13 17V5"/><path d="M8 17v-3"/></svg>
      Visão geral
    </button>
    <button type="button" role="tab" class="qmia-aba" [class.qmia-aba--ativa]="aba === 'conversas'"
            [attr.aria-selected]="aba === 'conversas'" (click)="selecioneAba('conversas')">
      <svg class="qmia-icone" viewBox="0 0 24 24" aria-hidden="true"><path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"/></svg>
      Conversas
    </button>
    <button type="button" role="tab" class="qmia-aba" [class.qmia-aba--ativa]="aba === 'relatorios'"
            [attr.aria-selected]="aba === 'relatorios'" (click)="selecioneAba('relatorios')">
      <svg class="qmia-icone" viewBox="0 0 24 24" aria-hidden="true"><path d="M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z"/><path d="M14 2v4a2 2 0 0 0 2 2h4"/><path d="M16 13H8"/><path d="M16 17H8"/></svg>
      Relatórios
      <span class="qmia-aba__contagem" *ngIf="relatorios.length">{{ relatorios.length }}</span>
    </button>
  </nav>

  <div class="qmia-painel">

    <!-- ===== Aba: Visão geral ===== -->
    <section class="qmia-visao" *ngIf="aba === 'visao'">
      <div class="qmia-carregando" *ngIf="carregando && !resumo"><span class="qmia-spinner"></span> carregando…</div>

      <div class="qmia-kpis" *ngIf="resumo">
        <div class="qmia-kpi">
          <span class="qmia-kpi__rotulo">Aprovação</span>
          <strong class="qmia-kpi__numero">{{ aprovacao }}<small>%</small></strong>
          <span class="qmia-kpi__frase">{{ resumo.positivas || 0 }} de {{ avaliaveis }} avaliáveis positivas</span>
        </div>
        <div class="qmia-kpi">
          <span class="qmia-kpi__rotulo">Avaliados</span>
          <strong class="qmia-kpi__numero">{{ resumo.avaliados || 0 }}<small>/{{ (resumo.avaliados || 0) + totalNaFila }}</small></strong>
          <span class="qmia-kpi__frase">{{ totalNaFila ? totalNaFila + ' na fila do período' : 'fila zerada no período' }}</span>
        </div>
        <div class="qmia-kpi">
          <span class="qmia-kpi__rotulo">Custo do juiz</span>
          <strong class="qmia-kpi__numero qmia-kpi__numero--texto">{{ custoFormatado(resumo.custoUsd) }}</strong>
          <span class="qmia-kpi__frase">{{ custoPorAvaliacao ? custoPorAvaliacao + ' por avaliação' : 'sem custo no período' }}</span>
        </div>
        <div class="qmia-kpi">
          <span class="qmia-kpi__rotulo">Reincidência</span>
          <strong class="qmia-kpi__numero">{{ categorias.length }}<small>{{ categorias.length === 1 ? ' padrão' : ' padrões' }}</small></strong>
          <span class="qmia-kpi__frase">{{ totalFalhas }} {{ totalFalhas === 1 ? 'falha agrupada' : 'falhas agrupadas' }} por categoria</span>
        </div>
      </div>

      <div class="qmia-cartao" *ngIf="resumo && distribuicao.length">
        <div class="qmia-cartao__cabecalho">
          <h2 class="qmia-cartao__titulo">Distribuição dos vereditos</h2>
          <span class="qmia-cartao__dica">clique para abrir os atendimentos</span>
        </div>
        <div class="qmia-distribuicao">
          <button type="button" *ngFor="let fatia of distribuicao"
                  class="qmia-distribuicao__fatia qmia-distribuicao__fatia--{{ fatia.chave }}"
                  [class.qmia-distribuicao__fatia--apagada]="temFiltroDeFatia && !fatiaAtiva(fatia)"
                  [style.flex-grow]="fatia.total"
                  [title]="fatia.rotulo + ': ' + fatia.total"
                  [attr.aria-label]="fatia.rotulo + ': ' + fatia.total"
                  (click)="cliqueFatia(fatia)"></button>
        </div>
        <div class="qmia-legenda">
          <button type="button" *ngFor="let fatia of distribuicao" class="qmia-legenda__item"
                  [class.qmia-legenda__item--ativa]="fatiaAtiva(fatia)"
                  (click)="cliqueFatia(fatia)">
            <span class="qmia-legenda__ponto qmia-distribuicao__fatia--{{ fatia.chave }}"></span>
            {{ fatia.rotulo }} <b>{{ fatia.total }}</b>
          </button>
        </div>
      </div>

      <div class="qmia-visao__colunas">
        <div class="qmia-cartao">
          <div class="qmia-cartao__cabecalho">
            <h2 class="qmia-cartao__titulo">Onde melhorar</h2>
            <span class="qmia-cartao__dica" *ngIf="categorias.length">{{ totalFalhas }} {{ totalFalhas === 1 ? 'falha' : 'falhas' }} em {{ categorias.length }} {{ categorias.length === 1 ? 'padrão' : 'padrões' }}</span>
          </div>
          <p class="qmia-vazio" *ngIf="!categorias.length">Nenhum padrão de falha no período.</p>
          <div class="qmia-causas" *ngIf="categorias.length">
            <button type="button" class="qmia-causa" *ngFor="let causa of categorias; let indice = index"
                    [class.qmia-causa--ativa]="filtroCategoria === causa.categoria"
                    (click)="filtrePorCategoria(causa.categoria)"
                    [title]="'Ver os atendimentos com ' + causa.rotulo">
              <span class="qmia-causa__numero">{{ indice + 1 | number:'2.0-0' }}</span>
              <span class="qmia-causa__conteudo">
                <span class="qmia-causa__linha">
                  <span class="qmia-causa__titulo">{{ causa.rotulo }}</span>
                  <span class="qmia-causa__casos">{{ causa.total }} {{ causa.total === 1 ? 'caso' : 'casos' }}</span>
                </span>
                <span class="qmia-causa__trilha"><span class="qmia-causa__barra" [style.width.%]="causa.percentual"></span></span>
              </span>
            </button>
          </div>
        </div>

        <div class="qmia-cartao">
          <div class="qmia-cartao__cabecalho">
            <h2 class="qmia-cartao__titulo">Varredura automática</h2>
          </div>
          <label class="qmia-switch">
            <input type="checkbox" [(ngModel)]="config.ativa"/>
            <span class="qmia-switch__trilha" aria-hidden="true"></span>
            <span class="qmia-switch__texto">Avaliação automática ativa
              <small>varredura a cada 10 min, atendimentos dos últimos 2 dias</small></span>
          </label>
          <div class="qmia-config__grupo">
            <span class="qmia-config__rotulo">Avaliar desfechos</span>
            <label class="qmia-config__caixa" *ngFor="let desfecho of desfechosDisponiveis">
              <input type="checkbox" [checked]="desfechoLigado(desfecho.chave)" (change)="alterneDesfecho(desfecho.chave)"/>
              {{ desfecho.rotulo }}
            </label>
          </div>
          <div class="qmia-config__grupo qmia-config__grupo--linha">
            <span class="qmia-config__rotulo">Vendas (PEDIDO_GERADO)</span>
            avaliar 1 a cada
            <input type="number" min="0" step="1" [(ngModel)]="config.amostragemPedidoGerado" aria-label="Amostragem de vendas"/>
            <span class="qmia-config__dica">0 = nenhuma venda entra na varredura</span>
          </div>
          <div class="qmia-config__grupo qmia-config__grupo--linha">
            <span class="qmia-config__rotulo">Modelo do juiz</span>
            <select [(ngModel)]="config.modelo" aria-label="Modelo do juiz">
              <option value="">Padrão do serviço</option>
              <option *ngFor="let modelo of modelosDoJuiz" [value]="modelo">{{ modelo }}</option>
            </select>
            <span class="qmia-config__dica">vale para a varredura e para o "Avaliar" manual</span>
          </div>
          <div class="qmia-config__acoes">
            <span class="qmia-config__salvo" *ngIf="configSalva" role="status">Configuração salva</span>
            <button type="button" class="qmia-botao qmia-botao--primario" (click)="salveConfig()" [disabled]="salvandoConfig">
              <span class="qmia-spinner qmia-spinner--claro" *ngIf="salvandoConfig"></span>
              {{ salvandoConfig ? 'Salvando…' : 'Salvar' }}
            </button>
          </div>
        </div>
      </div>
    </section>

    <!-- ===== Aba: Conversas (master-detail) ===== -->
    <section class="qmia-conversas" *ngIf="aba === 'conversas'">

      <!-- Faixa de contexto: aprovação, distribuição e filtros ativos -->
      <div class="qmia-contexto" *ngIf="resumo && distribuicao.length">
        <span class="qmia-contexto__stat"><b>{{ aprovacao }}%</b> de aprovação</span>
        <div class="qmia-distribuicao qmia-distribuicao--fina">
          <button type="button" *ngFor="let fatia of distribuicao"
                  class="qmia-distribuicao__fatia qmia-distribuicao__fatia--{{ fatia.chave }}"
                  [class.qmia-distribuicao__fatia--apagada]="temFiltroDeFatia && !fatiaAtiva(fatia)"
                  [style.flex-grow]="fatia.total"
                  [title]="fatia.rotulo + ': ' + fatia.total"
                  [attr.aria-label]="fatia.rotulo + ': ' + fatia.total"
                  (click)="cliqueFatia(fatia)"></button>
        </div>
        <div class="qmia-legenda qmia-legenda--compacta">
          <button type="button" *ngFor="let fatia of distribuicao" class="qmia-legenda__item"
                  [class.qmia-legenda__item--ativa]="fatiaAtiva(fatia)"
                  (click)="cliqueFatia(fatia)">
            <span class="qmia-legenda__ponto qmia-distribuicao__fatia--{{ fatia.chave }}"></span>
            {{ fatia.rotulo }} <b>{{ fatia.total }}</b>
          </button>
        </div>
        <span class="qmia-contexto__filtro" *ngIf="filtroCategoria">
          {{ rotuloCategoria(filtroCategoria) }}
          <button type="button" (click)="filtrePorCategoria(filtroCategoria)" aria-label="Remover filtro de categoria">
            <svg class="qmia-icone" viewBox="0 0 24 24" aria-hidden="true"><path d="M18 6 6 18"/><path d="m6 6 12 12"/></svg>
          </button>
        </span>
        <button type="button" class="qmia-contexto__limpar" *ngIf="temFiltro" (click)="limpeFiltros()">limpar filtros</button>
      </div>

      <div class="qmia-corpo">
        <aside class="qmia-lista">
          <div class="qmia-lista__cabecalho">
            <span>{{ itens.length }} {{ itens.length === 1 ? 'atendimento' : 'atendimentos' }}</span>
            <span class="qmia-lista__filtrado" *ngIf="temFiltro">filtrado</span>
          </div>

          <div class="qmia-carregando" *ngIf="carregando"><span class="qmia-spinner"></span> carregando…</div>
          <p class="qmia-vazio" *ngIf="!carregando && !itens.length">
            {{ filtroFila ? 'Nada na fila do período.' : 'Nenhum atendimento no período com esses filtros.' }}
          </p>

          <button type="button" class="qmia-item" *ngFor="let item of itens; trackBy: rastreieItem"
                  [class.qmia-item--selecionado]="item.atendimentoId === selecionadoId"
                  (click)="selecione(item)">
            <span class="qmia-item__linha1">
              <span class="qmia-veredito" [ngClass]="'qmia--' + classeVeredito(item.veredito)">
                <ng-container *ngTemplateOutlet="iconeVeredito; context: { $implicit: classeVeredito(item.veredito) }"></ng-container>
                {{ item.aberto ? 'Em andamento' : rotuloVeredito(item.veredito) }}
              </span>
              <span class="qmia-item__hora">{{ item.abertoEm | date:'dd/MM HH:mm' }}</span>
            </span>
            <span class="qmia-item__titulo" *ngIf="item.titulo">{{ item.titulo }}</span>
            <span class="qmia-item__contato">
              <span class="qmia-avatar" [style.background]="corAvatar(item)">{{ iniciais(item) }}</span>
              <span class="qmia-item__nome">{{ nomeDoContato(item) }}</span>
            </span>
            <span class="qmia-item__meta">
              #{{ item.atendimentoId }}<ng-container *ngIf="item.nomeContato"> · {{ telefoneFormatado(item.telefone) }}</ng-container><ng-container *ngIf="item.desfecho"> · {{ item.desfecho }}<ng-container *ngIf="item.motivo">/{{ item.motivo }}</ng-container></ng-container>
            </span>
            <span class="qmia-item__categorias" *ngIf="item.categorias.length">
              <span class="qmia-tag" *ngFor="let categoria of item.categorias">{{ rotuloCategoria(categoria) }}</span>
            </span>
            <span class="qmia-item__resumo" *ngIf="item.resumo">“{{ item.resumo }}”</span>
          </button>
        </aside>

        <section class="qmia-conversa">
          <div class="qmia-conversa__vazia" *ngIf="!selecionadoId">
            <svg class="qmia-conversa__vazia-icone" viewBox="0 0 24 24" aria-hidden="true"><path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"/></svg>
            <p>Escolha um atendimento na lista<br>para ver a conversa e o laudo do juiz.</p>
          </div>

          <ng-container *ngIf="selecionadoId">
            <header class="qmia-conversa__cabecalho">
              <button type="button" class="qmia-conversa__voltar" (click)="fecheConversa()" aria-label="Voltar para a lista">
                <svg class="qmia-icone" viewBox="0 0 24 24" aria-hidden="true"><path d="m12 19-7-7 7-7"/><path d="M19 12H5"/></svg>
              </button>
              <div class="qmia-avatar qmia-avatar--grande" *ngIf="detalhe"
                   [style.background]="corAvatar(detalhe.atendimento)">
                {{ iniciais(detalhe.atendimento) }}
              </div>
              <div class="qmia-conversa__contato" *ngIf="detalhe">
                <a class="qmia-conversa__nome"
                   [routerLink]="['/admin/contatos', linkDoContato(detalhe.atendimento?.telefone)]"
                   title="Abrir o cadastro deste contato">
                  <b>{{ nomeDoContato(detalhe.atendimento) }}</b>
                </a>
                <span>
                  <ng-container *ngIf="detalhe.atendimento?.nomeContato">{{ telefoneFormatado(detalhe.atendimento?.telefone) }} · </ng-container>#{{ detalhe.atendimento?.id }} ·
                  {{ detalhe.atendimento?.abertoEm | date:'dd/MM HH:mm' }}<ng-container *ngIf="detalhe.atendimento?.encerradoEm">–{{ detalhe.atendimento?.encerradoEm | date:'HH:mm' }}</ng-container>
                  <span class="qmia-tag qmia-tag--andamento" *ngIf="detalhe.atendimento?.aberto">em andamento</span>
                </span>
              </div>
              <button type="button" class="qmia-botao qmia-botao--primario qmia-conversa__avaliar" (click)="avalie()"
                      [disabled]="avaliando || carregandoDetalhe"
                      [title]="detalhe?.avaliacao ? 'Julgar de novo com o prompt atual (sobrescreve)' : 'Mandar o juiz avaliar esta conversa'">
                <span class="qmia-spinner qmia-spinner--claro" *ngIf="avaliando"></span>
                <svg class="qmia-icone" *ngIf="!avaliando" viewBox="0 0 24 24" aria-hidden="true"><path d="m14 13-7.5 7.5a2.12 2.12 0 0 1-3-3L11 10"/><path d="m16 16 6-6"/><path d="m8 8 6-6"/><path d="m9 7 8 8"/><path d="m21 11-8-8"/></svg>
                {{ avaliando ? 'Avaliando…' : (detalhe?.avaliacao ? 'Reavaliar' : 'Avaliar') }}
              </button>
            </header>

            <div class="qmia-carregando" *ngIf="carregandoDetalhe"><span class="qmia-spinner"></span> carregando conversa…</div>

            <!-- Laudo + conversa rolam juntos: o laudo não rouba a altura do chat -->
            <div class="qmia-chat" *ngIf="!carregandoDetalhe && detalhe">
              <section class="qmia-laudo" *ngIf="detalhe.avaliacao"
                       [ngClass]="'qmia-laudo--' + classeVeredito(detalhe.avaliacao.veredito)">
                <div class="qmia-laudo__linha">
                  <span class="qmia-veredito" [ngClass]="'qmia--' + classeVeredito(detalhe.avaliacao.veredito)">
                    <ng-container *ngTemplateOutlet="iconeVeredito; context: { $implicit: classeVeredito(detalhe.avaliacao.veredito) }"></ng-container>
                    {{ rotuloVeredito(detalhe.avaliacao.veredito) }}
                    <ng-container *ngIf="detalhe.falhas?.length"> · {{ detalhe.falhas.length }} {{ detalhe.falhas.length === 1 ? 'falha' : 'falhas' }}</ng-container>
                  </span>
                  <span class="qmia-laudo__meta">
                    {{ detalhe.avaliacao.disparo }} · {{ detalhe.avaliacao.modelo }} · v{{ detalhe.avaliacao.versaoPrompt }}
                    · {{ custoFormatado(detalhe.avaliacao.custoUsd) }}
                  </span>
                </div>
                <h2 class="qmia-laudo__titulo" *ngIf="detalhe.avaliacao.titulo">{{ detalhe.avaliacao.titulo }}</h2>
                <p class="qmia-laudo__resumo" *ngIf="detalhe.avaliacao.resumo">“{{ detalhe.avaliacao.resumo }}”</p>
                <p class="qmia-laudo__classificacao">
                  <ng-container *ngIf="!detalhe.atendimento?.aberto">Classificação: {{ detalhe.atendimento?.tipoAtendimento }} · {{ detalhe.atendimento?.desfecho }}<ng-container *ngIf="detalhe.atendimento?.motivo"> · {{ detalhe.atendimento?.motivo }}</ng-container></ng-container>
                  <ng-container *ngIf="detalhe.atendimento?.aberto">Avaliação parcial — a conversa ainda estava em andamento</ng-container>
                </p>

                <!-- Falhas compactas: a evidência mora na bolha anotada; aqui só o atalho -->
                <ol class="qmia-laudo__falhas" *ngIf="detalhe.falhas?.length">
                  <li *ngFor="let falha of detalhe.falhas; let indice = index">
                    <button type="button" class="qmia-falha" (click)="roleAteFalha(falha)" [disabled]="!falha.turnoId"
                            [attr.aria-label]="falha.turnoId ? 'Mostrar o trecho na conversa' : null"
                            [title]="falha.turnoId ? 'Mostrar o trecho na conversa' : ''">
                      <span class="qmia-falha__numero">{{ indice + 1 }}</span>
                      <span class="qmia-falha__conteudo">
                        <span class="qmia-tag">{{ rotuloCategoria(falha.categoria) }}</span>
                        <span class="qmia-falha__explicacao">{{ falha.explicacao }}</span>
                      </span>
                      <svg class="qmia-icone qmia-falha__seta" *ngIf="falha.turnoId" viewBox="0 0 24 24" aria-hidden="true"><path d="M12 5v14"/><path d="m6 13 6 6 6-6"/></svg>
                    </button>
                  </li>
                </ol>
              </section>

              <ng-container *ngFor="let turno of detalhe.turnos; trackBy: rastreieTurno">
                <div class="qmia-sistema" *ngIf="turno.papel === 'sistema'">{{ turno.texto }}</div>

                <div class="qmia-bolha-wrapper" *ngIf="turno.papel !== 'sistema'"
                     [id]="'qmia-turno-' + turno.id"
                     [class.qmia-bolha-wrapper--direita]="turno.papel !== 'cliente'">
                  <div class="qmia-bolha"
                       [class.qmia-bolha--cliente]="turno.papel === 'cliente'"
                       [class.qmia-bolha--mia]="turno.papel === 'mia'"
                       [class.qmia-bolha--atendente]="turno.papel === 'atendente'">
                    <div class="qmia-bolha__autor" *ngIf="turno.papel === 'atendente'">Atendente</div>
                    <div class="qmia-bolha__texto" [innerHTML]="turno.texto | formataWhatsapp"></div>
                    <div class="qmia-bolha__meta">{{ turno.criadoEm | date:'HH:mm' }}</div>

                    <div class="qmia-anotacao" *ngFor="let falha of falhasDoTurno(turno)">
                      <b>{{ rotuloCategoria(falha.categoria) }}</b> — {{ falha.explicacao }}
                    </div>
                  </div>
                </div>
              </ng-container>
            </div>
          </ng-container>
        </section>
      </div>
    </section>

    <!-- ===== Aba: Relatórios ===== -->
    <section class="qmia-relatorios" *ngIf="aba === 'relatorios'">
      <aside class="qmia-relatorios__nav">
        <button type="button" class="qmia-botao qmia-botao--primario qmia-relatorios__gerar" (click)="gereRelatorio()"
                [disabled]="gerandoRelatorio"
                title="Monta o relatório do período a partir das avaliações já feitas">
          <span class="qmia-spinner qmia-spinner--claro" *ngIf="gerandoRelatorio"></span>
          <svg class="qmia-icone" *ngIf="!gerandoRelatorio" viewBox="0 0 24 24" aria-hidden="true"><path d="M9.9 15.5a2 2 0 0 0-1.4-1.4L2.4 12.5a.5.5 0 0 1 0-1L8.5 9.9a2 2 0 0 0 1.4-1.4l1.6-6.1a.5.5 0 0 1 1 0l1.6 6.1a2 2 0 0 0 1.4 1.4l6.1 1.6a.5.5 0 0 1 0 1l-6.1 1.6a2 2 0 0 0-1.4 1.4l-1.6 6.1a.5.5 0 0 1-1 0z"/></svg>
          {{ gerandoRelatorio ? 'Gerando…' : 'Gerar relatório' }}
        </button>
        <p class="qmia-relatorios__dica">O relatório reúne as avaliações dos últimos {{ diasSelecionados }} {{ diasSelecionados === 1 ? 'dia' : 'dias' }} (o período selecionado acima).</p>

        <p class="qmia-vazio" *ngIf="!relatorios.length">Nenhum relatório ainda. Gere o primeiro com o botão acima.</p>

        <div class="qmia-relatorios__lista" *ngIf="relatorios.length">
          <button type="button" class="qmia-rel-cartao" *ngFor="let relatorio of relatorios"
                  [class.qmia-rel-cartao--ativo]="relatorioAberto === relatorio"
                  (click)="selecioneRelatorio(relatorio)">
            <span class="qmia-rel-cartao__periodo">{{ relatorio.periodoDe | date:'dd/MM' }} – {{ relatorio.periodoAte | date:'dd/MM' }}</span>
            <!-- relatório determinístico não tem modelo nem custo: só a data -->
            <span class="qmia-rel-cartao__meta">gerado {{ relatorio.criadoEm | date:'dd/MM HH:mm' }}<ng-container *ngIf="relatorio.modelo"> · {{ custoFormatado(relatorio.custoUsd) }}</ng-container></span>
            <span class="qmia-rel-cartao__selos" *ngIf="relatorio.totalItens">
              <span class="qmia-selo qmia-selo--neutro">{{ relatorio.totalItens }} {{ relatorio.totalItens === 1 ? 'ponto' : 'pontos' }}</span>
              <span class="qmia-selo qmia-selo--alta" *ngIf="relatorio.altas">{{ relatorio.altas }} {{ relatorio.altas === 1 ? 'alta' : 'altas' }}</span>
            </span>
          </button>
        </div>
      </aside>

      <!-- (click): delegação para os "#id" injetados no HTML do markdown -->
      <article class="qmia-artigo" *ngIf="relatorioAberto" (click)="cliqueNoTexto($event)">
        <header class="qmia-artigo__cabecalho">
          <h2>Relatório {{ relatorioAberto.periodoDe | date:'dd/MM' }} – {{ relatorioAberto.periodoAte | date:'dd/MM' }}</h2>
          <span class="qmia-artigo__meta">
            gerado {{ relatorioAberto.criadoEm | date:'dd/MM HH:mm' }}<ng-container *ngIf="relatorioAberto.modelo"> · {{ relatorioAberto.modelo }} · {{ custoFormatado(relatorioAberto.custoUsd) }}</ng-container>
          </span>
        </header>

        <ng-container *ngIf="relatorioAberto.itens?.length; else textoCorrido">
          <section class="qmia-ponto" *ngFor="let item of relatorioAberto.itens"
                   [class.qmia-ponto--geral]="item.geral">
            <header class="qmia-ponto__topo">
              <span class="qmia-ponto__numero">{{ item.numero | number:'2.0-0' }}</span>
              <!-- Uma linha só: o título fecha no "#id" e qualquer quebra entre as tags viraria espaço. -->
              <span class="qmia-ponto__titulo"><ng-container *ngTemplateOutlet="blocoPartes; context: { $implicit: item.tituloPartes }"></ng-container></span>
              <span class="qmia-selo" *ngIf="item.prioridade"
                    [ngClass]="'qmia-selo--' + item.prioridade.toLowerCase()">{{ rotuloPrioridade(item.prioridade) }}</span>
              <span class="qmia-selo qmia-selo--geral" *ngIf="item.geral">Balanço</span>
            </header>
            <!-- Corpo em Markdown renderizado; os "#id" viram botão via rendaMarkdown -->
            <div class="qmia-ponto__texto qmia-md" [innerHTML]="item.html"></div>
          </section>
        </ng-container>

        <!-- Relatório sem itens numeráveis: o texto inteiro renderizado como md. -->
        <ng-template #textoCorrido>
          <div class="qmia-ponto__texto qmia-md" [innerHTML]="relatorioAberto.html"></div>
        </ng-template>
      </article>

      <div class="qmia-artigo qmia-artigo--vazio" *ngIf="!relatorioAberto">
        <p class="qmia-vazio">{{ relatorios.length ? 'Escolha um relatório na lista para ler.' : 'Os relatórios gerados aparecem aqui.' }}</p>
      </div>
    </section>
  </div>
</div>

<!-- Ícone de veredito (SVG por classe) — usado na lista e no laudo -->
<ng-template #iconeVeredito let-classe>
  <svg class="qmia-icone qmia-icone--veredito" viewBox="0 0 24 24" aria-hidden="true" [ngSwitch]="classe">
    <g *ngSwitchCase="'positiva'"><circle cx="12" cy="12" r="9"/><path d="m8.4 12.4 2.4 2.4 4.8-5"/></g>
    <g *ngSwitchCase="'ressalva'"><circle cx="12" cy="12" r="9"/><path d="M12 7.5v5"/><path d="M12 16.2h.01"/></g>
    <g *ngSwitchCase="'negativa'"><circle cx="12" cy="12" r="9"/><path d="m9.2 9.2 5.6 5.6"/><path d="m14.8 9.2-5.6 5.6"/></g>
    <g *ngSwitchCase="'neutra'"><circle cx="12" cy="12" r="9"/><path d="M8.5 12h7"/></g>
    <g *ngSwitchDefault><circle cx="12" cy="12" r="9"/><path d="M12 7.5V12l3 1.8"/></g>
  </svg>
</ng-template>

<!-- Pedaços do TÍTULO do item: "#id" abre a conversa. Uma linha para não sobrar espaço. -->
<ng-template #blocoPartes let-partes><ng-container *ngFor="let parte of partes" [ngSwitch]="parte.tipo"><button *ngSwitchCase="'ref'" type="button" class="qmia-ref" (click)="abraAtendimento(parte.atendimentoId)" title="Abrir esta conversa na aba Conversas">#{{ parte.atendimentoId }}</button><span *ngSwitchCase="'citacao'" class="qmia-citacao">“{{ parte.citacao }}”</span><ng-container *ngSwitchDefault>{{ parte.texto }}</ng-container></ng-container></ng-template>
